var map = {
	"./el_fats_purple_cart.png": 9407,
	"./en_fats_purple_cart.png": 14397,
	"./it_fats_purple_cart.png": 84563,
	"./ro_fats_purple_cart.png": 83509,
	"./uk_fats_purple_cart.png": 92082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45599;